import React, { Component } from 'react';
import { connect } from "react-redux";
import DownloadIcon from '../../../assets/images/downloadIcon.svg';
import CustomSelect from "../../../components/common/select/Select";
import ProductMiddleware from "../../../store/prat_middleware/gt/productMiddleware";
import InnovationMiddleware from '../../../store/middleware/innovationMiddleware';
import { compare } from '../../../prat_screen/gt/validation/sort';
import DATA from '../../../assets/data';
import { Loader } from "../../../components/loader";
import './InnovationList.styles.scss';
import CustomToast from '../../../util-functions/customToast';

export class InnovationList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedBrands: [],
            selectedCategories: [],
            selectedMasterSkus: [],
            myBrands: [],
            myMasterSkus: [],
            pageNo: 1,
            selectedYear: new Date().getFullYear(),
            selectedInnoStatus: [],
            selectedCodes: [],
            listData: [],
            getData: true,
            isDeleting: false
        }
    }

    componentDidMount() {
        this.props.productCategories();
        this.props.productBrands();
        this.props.productMasterSkus();
        this.props.getInnovationList(
            this.state.pageNo,
            this.state.selectedCategories,
            this.state.selectedBrands,
            this.state.selectedMasterSkus,
            this.state.selectedInnoStatus
        );
    };

    handleScroll = (e) => {
        const { innovationListArray } = this.props
        let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;
        if (innovationListArray && bottom && this.state.listData.length < innovationListArray.total_count) {
            let page = this.state.pageNo + 1;
            this.setState({
                pageNo: page,
                getData: true
            }, () => {
                this.props.getInnovationList(
                    page,
                    this.state.selectedCategories,
                    this.state.selectedBrands,
                    this.state.selectedMasterSkus,
                    this.state.selectedInnoStatus
                );
            })
        }
    };

    handleCategory = category => {
        if (category == null || category.length === 0) {
            this.setState({
                myBrands: [], myMasterSkus: [], selectedCategories: [], selectedBrands: [], selectedMasterSkus: []
            })
        }
        else if (category) {
            let arr = [];
            category.forEach(element => {
                arr.push(element.value);
            });

            this.setState({ selectedCategories: arr, }, () => {
                this.handleFilteredBrands();
            });
        }
    };


    handleFilteredBrands = () => {
        const {
            selectedCategories,
            selectedBrands
        } = this.state;
        const { productBrandsArray } = this.props;
        let filteredbrands = [];
        if (selectedCategories.length) {
            for (let i = 0; i < selectedCategories.length; i++) {
                filteredbrands.push(
                    ...productBrandsArray.filter(item => {
                        return item.Category === selectedCategories[i];
                    })
                );
            }
            let arr = [];
            if (selectedBrands.length) {
                filteredbrands.forEach(item => {
                    if (selectedBrands.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedBrands: arr });
            }

            this.setState({
                myBrands: filteredbrands
            }, () =>
                this.handleFilteredMasterSku()
            );
        }
    };

    handleBrandChange = selectedBrands => {
        if (selectedBrands == null || selectedBrands.length === 0) {
            this.setState({
                myMasterSkus: [], selectedBrands: [], selectedMasterSkus: []
            })

        }
        else if (selectedBrands) {
            let arr = [];
            selectedBrands.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedBrands: arr }, () => {
                this.handleFilteredMasterSku();
            });
        }
    };

    handleFilteredMasterSku = () => {
        const {
            selectedBrands,
            selectedMasterSkus,
        } = this.state;
        const { productMasterSkusArray } = this.props;
        let filteredSkus = [];
        if (selectedBrands.length) {
            for (let i = 0; i < selectedBrands.length; i++) {
                filteredSkus.push(
                    ...productMasterSkusArray.filter(item => {
                        return item.Brand === selectedBrands[i];
                    })
                );
            }

            let arr = [];
            if (selectedMasterSkus.length) {
                filteredSkus.forEach(item => {
                    if (selectedMasterSkus.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedMasterSkus: arr });
            }
            this.setState({
                myMasterSkus: filteredSkus
            });
        }
    };

    handleMasterSkusChange = selectedMasterSkus => {
        if (selectedMasterSkus == null || selectedMasterSkus.length === 0) {
            this.setState({
                selectedMasterSkus: []
            })
        }
        if (selectedMasterSkus) {
            let arr = [];
            selectedMasterSkus.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedMasterSkus: arr });
        }
    };

    getList = (data) => {
        if (data && this.state.getData) {
            this.setState({
                listData: [...this.state.listData, ...data.results],
                getData: false
            })
        }
    };

    handleCreateInnovatonPromotion = () => {
        window.open(`/innovationform/?id=`, '_self')
    };

    handleActivityOpen = (item) => {
        window.open(`/innovationform/?id=${item.guid}`, '_blank')
    };

    handleInnoStatusChange = value => {
        if (value == null || value.length === 0) {
            this.setState({
                selectedInnoStatus: []
            })
        }
        if (value) {
            let arr = [];
            value.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedInnoStatus: arr });
        }
    };

    handleSubmit = () => {
        this.setState({
            listData: [],
            getData: true
        }, () => {
            this.props.getInnovationList(
                1,
                this.state.selectedCategories,
                this.state.selectedBrands,
                this.state.selectedMasterSkus,
                this.state.selectedInnoStatus
            );
        })
    };

    handleActivityDelete = (id) => {
        this.setState({
            isDeleting: true
        },()=>{
            this.props.deleteInnovationPromotion(id);
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if ((prevProps.innovationListArray !== this.props.innovationListArray) && this.state.getData) {
            this.getList(this.props.innovationListArray);
        }

        if (prevProps.deleteInnovation !== this.props.deleteInnovation && this.state.isDeleting) {
            if(this.props.deleteInnovation === ''){
                CustomToast('success', 'Promotion deleted successfully!');
                console.log('deleting')
                this.setState({
                    isDeleting: false
                },()=>{
                    this.handleSubmit()
                })
            }
        }
    };

    render() {
        const { myBrands, selectedBrands, selectedCategories, myMasterSkus, selectedMasterSkus,
            listData, selectedInnoStatus } = this.state;

        const { productCategoriesArray, productBrandsArray, productMasterSkusArray,
             isInnovationListLoading } = this.props;
        return (
            <>
                {
                    listData.length === 0 && isInnovationListLoading
                        ?
                        <Loader flag={true} />
                        :
                        <div className="page-container">
                            <div className="heading-and-download-container">
                                <div className='component-heading' style={{ padding: 0 }}>Innovation List</div>
                                <div>
                                    <img
                                        style={{ marginLeft: "16px", cursor: "pointer" }}
                                        src={DownloadIcon}
                                        onClick={() => { }}
                                        alt=""
                                    />
                                </div>
                            </div>

                            <div className="header">
                                <div className="headers_controller">
                                    <div className="selectors ">

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Category"}
                                            allowSelectAll={true}
                                            isDisabled={productCategoriesArray?.length ? false : true}
                                            isMulti
                                            options={
                                                productCategoriesArray
                                                    ? productCategoriesArray?.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: item.Name
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleCategory}
                                            value={
                                                productCategoriesArray
                                                    ? productCategoriesArray
                                                        .filter(item => {
                                                            return selectedCategories.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        }) : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Brand"}
                                            allowSelectAll={true}
                                            isDisabled={productBrandsArray?.length ? false : true}
                                            isMulti
                                            options={
                                                myBrands
                                                    ? myBrands.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: item.Name
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleBrandChange}
                                            value={
                                                myBrands
                                                    ? myBrands
                                                        .filter(item => {
                                                            return selectedBrands.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        }) : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"MSKU"}
                                            allowSelectAll={true}
                                            isDisabled={productMasterSkusArray?.length ? false : true}
                                            isMulti
                                            options={
                                                myMasterSkus
                                                    ? myMasterSkus.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: `${item.Description} (${item.Code}) `
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleMasterSkusChange}
                                            value={
                                                myMasterSkus
                                                    ? myMasterSkus
                                                        .filter(item => {
                                                            return selectedMasterSkus.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: `${item.Description} (${item.Code}) `
                                                            };
                                                        })
                                                    : []
                                            }
                                        />

                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Status"}
                                            allowSelectAll={true}
                                            isMulti
                                            options={DATA.CP_STATUS
                                                .map(item => {
                                                    return {
                                                        value: item.value2,
                                                        label: item.label
                                                    };
                                                })
                                            }
                                            onChange={this.handleInnoStatusChange}
                                            value={DATA.CP_STATUS
                                                .filter(item => {
                                                    return selectedInnoStatus.includes(item.value2);
                                                })
                                                .map(item => {
                                                    return {
                                                        value: item.value2,
                                                        label: item.label
                                                    };
                                                })
                                            }
                                        />

                                    </div>
                                </div>
                                <div className="headers_action" style={{ justifyContent: 'flex-end' }}>
                                    <div className="control_submit" style={{ textAlign: 'right', width: 'min-content' }} >
                                        <button className="__submit_button" onClick={this.handleSubmit} style={{ marginBottom: '8px' }}>
                                            SUBMIT
                            </button>
                                        <button
                                            className="create_new"
                                            style={{ outline: 'none' }}
                                            onClick={this.handleCreateInnovatonPromotion}
                                        >
                                            + Create New
                            </button>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="promotion-list-table-container"
                                onScroll={e => this.handleScroll(e)}
                            >

                                <table className='promotion-list-table'>

                                    <thead>

                                        <tr>

                                            <th
                                                className='cell-without-white-warp header-cell-bg'
                                                style={{ textAlign: 'left' }}
                                            >
                                                Dummy MSKU Code
                                            </th>
                                            <th
                                                className='cell-without-white-warp header-cell-bg'
                                                style={{ textAlign: 'left' }}
                                            >
                                                Reference MSKU Code
                                            </th>
                                            <th
                                                className='promolist-table-cell-padding header-cell-bg'
                                                style={{ textAlign: 'center' }}
                                            >
                                                Mapped MSKU Code
                                            </th>
                                            <th
                                                className='promolist-table-cell-padding header-cell-bg'
                                                style={{ textAlign: 'center' }}
                                            >
                                                Status
                                            </th>
                                            <th
                                                className='promolist-table-cell-padding header-cell-bg'
                                                style={{ textAlign: 'left' }}
                                            >
                                                Category
                                            </th>
                                            <th
                                                className='promolist-table-cell-padding header-cell-bg'
                                                style={{ textAlign: 'left' }}
                                            >
                                                Brand
                                            </th>
                                            <th
                                                className='promolist-table-cell-padding header-cell-bg'
                                                style={{ textAlign: 'center' }}
                                            >
                                                Dummy MSKU Description
                                            </th>
                                            <th
                                                className='promolist-table-cell-padding header-cell-bg'
                                                style={{ textAlign: 'center' }}
                                            >
                                                View
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {
                                            listData && listData
                                                .map(rowItem => (
                                                    <tr className='row-border' key={rowItem.guid}>
                                                        <td
                                                            className='cell-without-white-warp'
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => this.handleActivityOpen(rowItem)}
                                                        >
                                                            {rowItem.DummyCode ? rowItem.DummyCode : '--'}
                                                        </td>
                                                        <td
                                                            className='cell-without-white-warp'
                                                        >
                                                            {rowItem.ReferenceMasterSkuName ? rowItem.ReferenceMasterSkuName : '--'}
                                                        </td>
                                                        <td
                                                            className='cell-without-white-warp'
                                                        >
                                                            {rowItem.ReferenceMasterSku ? rowItem.ReferenceMasterSku : '--'}
                                                        </td>
                                                        <td
                                                            style={{ textAlign: 'left' }}
                                                            className='promolist-table-cell-padding'
                                                        >
                                                            <span
                                                                className={
                                                                    rowItem.Status === 0
                                                                        ? "draft-status cp-form-status" :
                                                                        rowItem.Status === 1
                                                                            ? "active-status cp-form-status" :
                                                                            rowItem.Status === 2
                                                                                ? 'deactive-status cp-form-status' : 'finalized-status cp-form-status'
                                                                }
                                                            >
                                                                { rowItem.Status === 0 ? 'Draft' : rowItem.Status === 1 ? 'Activated' : rowItem.Status === 2 ? 'Deactivated' : 'Finalized'}
                                                            </span>
                                                        </td>
                                                        <td
                                                            className='promolist-table-cell-padding'
                                                            style={{ textAlign: 'left' }}
                                                        >
                                                            {rowItem.CategoryName ?
                                                                <span className='cp-list-cat-tab'>
                                                                    {rowItem.CategoryName}
                                                                </span>
                                                                :
                                                                '--'
                                                            }
                                                        </td>
                                                        <td
                                                            className='promolist-table-cell-padding'
                                                            style={{ textAlign: 'left' }}
                                                        >
                                                            {rowItem.BrandName ?
                                                                <span className='cp-list-cat-tab'>
                                                                    {rowItem.BrandName}
                                                                </span>
                                                                :
                                                                '--'
                                                            }
                                                        </td>
                                                        <td
                                                            className='cell-without-white-warp'
                                                        >
                                                            {rowItem.DummyDescription ? rowItem.DummyDescription : '--'}
                                                        </td>
                                                        <td
                                                            className='promolist-table-cell-padding'
                                                        >
                                                            <div className='cp-list-cat-tab cp-view-btn-cont'>
                                                                <img
                                                                    src={require("../../../prat_screen/gt/images/dots.png")}
                                                                    alt=""
                                                                />
                                                                <div className='cp-list-cat-tab cp-view-btn-sub-cont'>
                                                                    <span className='cp-view-btn' onClick={() => this.handleActivityOpen(rowItem)}>view</span>
                                                                    {rowItem.Status === 0 ? <span className='cp-view-btn' onClick={() => this.handleActivityDelete(rowItem.guid)}>delete</span> : null}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                        }

                                    </tbody>
                               
                                </table>

                            </div>

                        </div>
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        productCategoriesArray: state.ProductReducer.productCategories,
        productBrandsArray: state.ProductReducer.productBrands,
        productMasterSkusArray: state.ProductReducer.productMasterSkus,
        innovationListArray: state.InnovationReducer.innovationList,
        isInnovationListLoading: state.InnovationReducer.isInnovationListLoading,
        InnovationListHasError: state.InnovationReducer.InnovationListHasError,
        deleteInnovation: state.InnovationReducer.deleteInnovation,
        deleteInnovationIsLoading: state.InnovationReducer.deleteInnovationIsLoading,
        deleteInnovationHasError: state.InnovationReducer.deleteInnovationHasError
    };
};

const mapDispatchToProps = dispatch => {
    return {
        productCategories: () => {
            return dispatch(ProductMiddleware.get_categories());
        },
        productBrands: () => {
            return dispatch(ProductMiddleware.get_brands());
        },
        productMasterSkus: () => {
            return dispatch(ProductMiddleware.get_master_skus());
        },
        getInnovationList: (
            pageNo,
            selectedCategories,
            selectedBrands,
            selectedMasterSkus,
            selectedInnoStatus
        ) => {
            return dispatch(InnovationMiddleware.getInnovationList(
                pageNo,
                selectedCategories,
                selectedBrands,
                selectedMasterSkus,
                selectedInnoStatus
            ));
        },
        deleteInnovationPromotion: (id) => {
            return dispatch(InnovationMiddleware.deleteInnovationPromotion(id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InnovationList);
